import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import React, { useState } from 'react';
import { SketchPicker } from 'react-color';
import { MessageSourceProps, withMessages } from 'react-message-source';
import reactCSS from 'reactcss';
import rgbHex from 'rgb-hex';
import { Button, Popup } from 'semantic-ui-react';
import styled from 'styled-components';

const ColorPickerContainerDiv = styled.div`

  .choose-color-swatch {
    display: inline-block;
    padding: 5px;
    border-radius: 1px;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, .1);
    cursor: pointer;

    .choose-color-swatch-preview {
      width: 36px;
      height: 14px;
      border-radius: 2px;
    }
  }
`

const ColorPickerPopupContentDiv = styled.div`

  .actions-row {
    display: inline-flex;
    margin-top: 20px;

    button {
      margin-right: 0.75rem;
    }
  }
`

interface Props extends MessageSourceProps, AuthConsumerRenderProps {
  interventionColor: string,
  onSaveColor: (color: string) => void
}

const ChooseColorComponent = (props: Props) => {

  const {interventionColor, onSaveColor, getMessage} = props;

  const [color, setColor] = useState(interventionColor);
  const [displayColorPicker, setDisplayColorPicker] = useState(false);


  const handleChangeComplete = (color: any) => {
    setColor("#" + rgbHex(color.rgb.r, color.rgb.g, color.rgb.b, color.rgb.a));
  };

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  const handleClose = () => {
    if (interventionColor === color) {
      setColor(color);
    } else {
      setColor(interventionColor);
    }
    setDisplayColorPicker(false);
  };

  const handleChooseColor = () => {
    onSaveColor(color);
    setDisplayColorPicker(false);
  }

  const styles = reactCSS({
    'default': {
      color: {
        background: `${color}`
      }
    }
  });

  const trigger = (
      <div className="choose-color-swatch" onClick={handleClick}>
        <div className="choose-color-swatch-preview" style={styles.color}/>
      </div>
  );

  const content = (
      <ColorPickerPopupContentDiv>
        <SketchPicker
            styles={{
              default: {
                picker: {
                  padding: "0",
                  borderRadius: "0",
                  boxShadow: "none"
                }
              }
            }}
            color={color}
            onChangeComplete={(color) => {
              handleChangeComplete(color)
            }}
        />
        <div className="actions-row">
          <Button
              compact
              type="Submit"
              primary
              onClick={handleChooseColor}>
            {getMessage("button.choose")}
          </Button>

          <Button
              compact
              type="button"
              onClick={handleClose}
          >
            {getMessage("button.cancel")}</Button>
        </div>
      </ColorPickerPopupContentDiv>
  );

  return (
      <ColorPickerContainerDiv className="choose-color-box">
        <Popup
            trigger={trigger}
            open={displayColorPicker}
            popperDependencies={[displayColorPicker]}
            content={content}
            flowing
            on="click"
            size="large"
            onClose={handleClose}
        />
      </ColorPickerContainerDiv>
  );

}

export default withMessages(withAuthContext(ChooseColorComponent));
